'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var reactLaag = require('react-laag');
var framerMotion = require('framer-motion');
var ResizeObserver = require('resize-observer-polyfill');
var nanoid = require('nanoid');
var classNames = require('classnames/bind');
var Tooltip_module = require('./Tooltip.module.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var ResizeObserver__default = /*#__PURE__*/_interopDefaultLegacy(ResizeObserver);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var cx = classNames__default["default"].bind(Tooltip_module["default"]);
var positionMap = {
    top: 'TOP_CENTER',
    right: 'RIGHT_CENTER',
    bottom: 'BOTTOM_CENTER',
    left: 'LEFT_CENTER',
};
var Tooltip = function (_a) {
    var className = _a.className, _b = _a.tooltipPosition, tooltipPosition = _b === void 0 ? 'top' : _b, tooltipTitle = _a.tooltipTitle, tooltipDescription = _a.tooltipDescription, children = _a.children;
    var _c = reactLaag.useHover({ delayEnter: 300, delayLeave: 200 }), show = _c[0], hoverProps = _c[1];
    var uniqueId = React.useState(nanoid.nanoid())[0];
    var tooltipClassname = cx(Tooltip_module["default"].tooltip, className);
    return (jsxRuntime.jsx(reactLaag.ToggleLayer, _tslib.__assign({ ResizeObserver: ResizeObserver__default["default"], fixed: true, isOpen: show, closeOnDisappear: "full", placement: {
            anchor: positionMap[tooltipPosition],
            autoAdjust: true,
            triggerOffset: 8,
        }, renderLayer: function (_a) {
            var isOpen = _a.isOpen, layerProps = _a.layerProps, layerSide = _a.layerSide, arrowStyle = _a.arrowStyle;
            return isOpen && (jsxRuntime.jsx(framerMotion.AnimatePresence, { children: jsxRuntime.jsx("div", _tslib.__assign({ style: { width: 'inherit' } }, { children: jsxRuntime.jsxs(framerMotion.motion.span, _tslib.__assign({}, layerProps, { id: uniqueId, className: tooltipClassname, role: "tooltip", initial: {
                            opacity: 0,
                            scale: 0.8,
                            y: layerSide === 'top' ? -8 : 8,
                        }, animate: { opacity: 1, scale: 1, y: 0 }, exit: {
                            opacity: 0,
                            scale: 0.8,
                            y: layerSide === 'top' ? -8 : 8,
                        }, transition: {
                            type: 'spring',
                            damping: 30,
                            stiffness: 500,
                        } }, { children: [tooltipTitle && jsxRuntime.jsx("h6", _tslib.__assign({ className: Tooltip_module["default"].title }, { children: tooltipTitle })), tooltipDescription && jsxRuntime.jsx("p", _tslib.__assign({ className: Tooltip_module["default"].description }, { children: tooltipDescription })), jsxRuntime.jsx(reactLaag.Arrow, { style: arrowStyle, layerSide: layerSide, size: 8, angle: 45, roundness: 0.5, borderWidth: 1, borderColor: "#192B58", backgroundColor: "#192B58" })] })) })) }));
        } }, { children: function (_a) {
            var triggerRef = _a.triggerRef;
            return (jsxRuntime.jsx("div", _tslib.__assign({ ref: triggerRef }, hoverProps, { className: Tooltip_module["default"].tooltipChild }, { children: children })));
        } })));
};

exports["default"] = Tooltip;
//# sourceMappingURL=Tooltip.js.map
